import { PathnameEnum, styleConstant } from '@constant';
import { Box } from '@mui/material';
import { colorSet } from '@theme';
import { useLocation, useNavigate } from 'react-router';
import { Text, LogoutPopover } from '..';
import { useState } from 'react';
import { BookmarkPrimaryIcon, ProfileCirclePrimaryIcon, RefaLogoIcon } from '@assets/iconComponents';

export const MenuTop = () => {
  const [anchorEl, setAnchorEl] = useState<SVGSVGElement | null>(null);

  const navigate = useNavigate();
  const location = useLocation();
  const locationPathname = location.pathname;

  const navigationButtonList = [
    {
      pageName: '스탠다드 검색',
      pathname: PathnameEnum.STANDARD_OUTPUT_PAGE
    },
    {
      pageName: '19금',
      pathname: PathnameEnum.ADULTS_ONLY_OUTPUT_PAGE
    },
    {
      pageName: '액션 장르',
      pathname: PathnameEnum.ACTION_GENRE_OUTPUT_PAGE
    },
    {
      pageName: '표정',
      pathname: PathnameEnum.FACIAL_EXPRESSION_OUTPUT_PAGE
    },
    {
      pageName: '신체 부위',
      pathname: PathnameEnum.BODY_PART_OUTPUT_PAGE
    },
    {
      pageName: '기타',
      pathname: PathnameEnum.ETC_OUTPUT_PAGE
    },
    {
      pageName: '3D 소재',
      pathname: PathnameEnum.THREE_D_OUTPUT_PAGE
    }
  ];

  const handleLogoClick = () => {
    navigate(PathnameEnum.MAIN_PAGE);
  };

  const isPageSelected = (pathnameParam: PathnameEnum) => {
    return locationPathname.includes(pathnameParam);
  };

  const handleNavigationButtonClick = (pathnameParam: PathnameEnum) => {
    navigate(pathnameParam);
  };

  const handleCollectionButtonClick = () => {
    navigate(PathnameEnum.COLLECTION_LIST_PAGE);
  };

  const handlePopoverOpen = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        style={{
          width: '100%',
          height: styleConstant.menuTopHeight,
          borderBottom: `1px solid ${colorSet.gray200}`,
          backgroundColor: colorSet.white,
          padding: '0px 40px',
          display: 'inline-flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'fixed',
          left: 0,
          right: 0,
          top: 0,
          zIndex: styleConstant.zIndexMenuTop
        }}
      >
        <div style={{ height: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '40px' }}>
          <RefaLogoIcon onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
          <div style={{ height: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '32px' }}>
            {navigationButtonList.map((item) => (
              <div
                key={item.pageName}
                onClick={() => {
                  handleNavigationButtonClick(item.pathname);
                }}
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: `4px solid ${isPageSelected(item.pathname) ? colorSet.primaryMain : 'transparent'}`,
                  cursor: 'pointer'
                }}
              >
                <Text
                  variant="body1"
                  color={isPageSelected(item.pathname) ? colorSet.gray600 : colorSet.gray400}
                  fontWeight={isPageSelected(item.pathname) ? 'bold' : 'normal'}
                  marginTop="4px"
                >
                  {item.pageName}
                </Text>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
          <div
            onClick={handleCollectionButtonClick}
            style={{
              width: 101,
              height: 40,
              display: 'flex',
              flexDirection: 'row',
              gap: 4,
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '22px',
              border: `1px solid ${colorSet.primaryMain}`,
              cursor: 'pointer'
            }}
          >
            <BookmarkPrimaryIcon style={{ width: 16, height: 16 }} />
            <Text variant="body2" fontWeight="bold" color={colorSet.primaryMain}>
              컬렉션
            </Text>
          </div>
          <div>
            <ProfileCirclePrimaryIcon
              onClick={(e) => {
                handlePopoverOpen(e);
              }}
              style={{ cursor: 'pointer' }}
            />
            <LogoutPopover anchorEl={anchorEl} handlePopoverClose={handlePopoverClose} />
          </div>
        </div>
      </Box>
      <Box style={{ width: '100%', height: styleConstant.menuTopHeight }} />
    </>
  );
};
